import { 
  createApiFactory, 
  createPlugin, 
  createRoutableExtension, 
  createRouteRef, 
  discoveryApiRef, 
  fetchApiRef 
} from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
import { EpDevPSearchApiClient } from '@solace-labs/backstage-plugin-ep-devp-search-common';
import { epDevPSearchApiClientApiRef } from './apis';

export const rootRouteRef = createRouteRef({
  id: `${EpDevPPluginIds.EpDevPSearchPluginId}:route:root`,
});

export const epDevPSearchPlugin = createPlugin({
  id: EpDevPPluginIds.EpDevPSearchPluginId,
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: epDevPSearchApiClientApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new EpDevPSearchApiClient({
          discoveryApi: discoveryApi,
          fetchApi: fetchApi
        }),
    }),
  ]
});

export const EpDevPSearchPage = epDevPSearchPlugin.provide(
  createRoutableExtension({
    name: 'EpDevPSearchPage',
    component: () => import('./components/EpDevPSearchPage').then(m => m.EpDevPSearchPage),
    mountPoint: rootRouteRef,
  }),

);
